import { SelectItem } from '@/utils/types';
import { cnpController } from '../core';

export const getCnpListOptions = async (
  ...params: Parameters<typeof cnpController.getCnpList>
): Promise<SelectItem[]> => {
  const cnpList = await cnpController.getCnpList(...params);
  return cnpList.map((item) => ({
    label: item.displayName,
    value: item.uid,
  }));
};

export const getTenDlcCnpListOptions = async (
  params?: Record<string, boolean>
) => {
  const cnpList = await cnpController.getCnpList({
    ...params,
    channelId: '10DLC',
  });
  return cnpList.map((item) => ({
    label: item.displayName,
    value: item.uid,
  }));
};

export const getRcsCnpListOptions = async (
  params?: Record<string, boolean>
) => {
  const cnpList = await cnpController.getCnpList({
    ...params,
    channelId: 'RCS',
  });
  return cnpList.map((item) => ({
    label: item.displayName,
    value: item.uid,
  }));
};
